// Declare the application's top-level namespaces.
var gtn = gtn || {};
gtn.text = gtn.text || {};    // namespace for generic text-manipulation utilities.
gtn.ui = gtn.ui || {};        // namespace for generic UI-manipulation utilities.
gtn.page = gtn.page || {};    // namespace for page-specific functions.

// Disable AJAX caching on localhost (to facilitate editing). Enable it for production.
gtn.ajaxCache = (location.hostname == "localhost" ? false : true);

gtn.currentHash = location.hash;

gtn.getHash = function () {
    // Currently only supports version number and article section.
    var hash = location.hash;
    var hashObj = { version: "", section: "" };
    if (hash && hash.substring(0, 3) == "#!/") {
        var values = hash.substring(3).split("/");
        $.each(values, function (index, value) {
            if (value.substring(0, 8) == "version:") {
                // version number.
                hashObj.version = value.substring(8);
            } else {
                // article section.
                hashObj.section = value;
            }
        });
    }
    return hashObj;
};

gtn.setHash = function (field, value) {
    // Currently only supports version number and article section.
    var hashObj = gtn.getHash();
    if (field == "version") {
        // When version is being set (i.e. changed), discard the section value.
        hashObj.version = value;
        hashObj.section = "";
    } else {
        // When article section is being set, retain the version value.
        hashObj.section = value;
    }

    // Serialize the hash object into string.
    var hash = (hashObj.version ? "/version:" + hashObj.version : "");
    hash += (hashObj.section ? "/" + hashObj.section : "");
    gtn.currentHash = (hash ? "#!" + hash : "");
    // Record the hash in a global variable, so later we can distinguish
    // between hash change trigger by code and hash change trigger by user entry.
    location.hash = gtn.currentHash;
};

//Unused
gtn.ui.processIcons = function () {
    gtn.ui.myBookmarksMode = $(".m-main-content").hasClass("my-bookmarks");

    if (! gtn.ui.myBookmarksMode) {
        $(".article-title, .section-title").before("<div class='icon-menu'></div>");
    }

    $(".icon-menu").html("<div></div><div></div><div></div>");

    $(".icon-bookmark").html("<div class='bottom-notch'></div></div><div>");

    $(".icon-note").each(function () {
        // Save the note content as a data attribute, because the html will be dynamically changed.
        var content = $(this).html();
        $(this).data("content", content);

        if (gtn.ui.myBookmarksMode) {
            // Display the content directly.
            $(this).html("<div class='left-notch'></div><div>" + $(this).data("content") + "</div>");
        } else {
            // Hide the content and display the collapsed icon.
            $(this).html("<div class='left-notch'></div><div></div><div></div><div></div>");
        }
    }).mouseenter(function () {
        if (! $(this).hasClass("expanded")) {
            $(this).addClass("expanded")
                .html("<div class='left-notch'></div><div>" + $(this).data("content") + "</div>");
        }
    }).mouseleave(function () {
        if (! gtn.ui.myBookmarksMode) {
            $(this).removeClass("expanded")
                .html("<div class='left-notch'></div><div></div><div></div><div></div>");
        }
    });
};


gtn.ui.setTreePointer = function (e) {
    var offsetFromTreeTop = $(e.node).offset().top - $("#topicTree").offset().top;
    $(".tree-pointer").css({ top: offsetFromTreeTop, visibility: "visible" });
};

gtn.ui.setBookmarkCheckbox = function (e) {
    // Cancel the default "select" action that highlights the text.
    e.preventDefault();
    // Instead, use the action to toggle the checked state of the checkbox.
    var $checkbox = $(e.node).find(":checkbox");
    $checkbox.prop("checked", !$checkbox.prop("checked"));
};

// http://stackoverflow.com/questions/754607/can-jquery-get-all-css-styles-associated-with-an-element/6416527#6416527
$.fn.getStyleObject = function () {
    var dom = this.get(0);
    var style;
    var returns = {};
    if (window.getComputedStyle) {
        var camelize = function (a, b) {
            return b.toUpperCase();
        };
        style = window.getComputedStyle(dom, null);
        for (var i = 0, l = style.length; i < l; i++) {
            var prop = style[i];
            var camel = prop.replace(/\-([a-z])/g, camelize);
            var val = style.getPropertyValue(prop);
            returns[camel] = val;
        }
        return returns;
    }

    if (style = dom.currentStyle) {
        for (var prop in style) {
            returns[prop] = style[prop];
        }
        return returns;
    }

    return this.css();
};

// http://stackoverflow.com/questions/754607/can-jquery-get-all-css-styles-associated-with-an-element/6416527#6416527
$.fn.copyCSS = function ($source) {
    var styles = $source.getStyleObject();
    this.css(styles);
    return this;
};


gtn.ui.showFullLabelText = function ($label) {
    // If the visible width of the label doesn't accommodate the entire content (scrollWidth),
    // create a mouse-over layer to display the full text and mimic the visual styles of the label.
    if ($label.outerWidth() < $label[0].scrollWidth) {

        // Create the mouse-over layer if it doesn't exist.
        var $topicMouseOver = $("#topicMouseOver");
        if ($topicMouseOver.length == 0) {
            $(".m-main-content").append("<div id='topicMouseOver'></div>");
            $topicMouseOver = $("#topicMouseOver");
        }

        if ($label.prop("tagName").toLowerCase() == "a") {
            // This is a hyperlink label. Copy the link to the mouse-over layer.
            $topicMouseOver.html("<a href='" + $label.attr("href") + "'>" + $label.text() + "</a>")

        } else {
            // This is a plain text label. Copy the text content to the mouse-over layer.
            $topicMouseOver.text($label.text());
        }

        var isFForIE = $("html").is(".k-ie, .k-ff");

        $topicMouseOver
            // Copy all visual styles (defined, computed or inherited) from $label to the mouse-over layer.
            // Even though using copyCSS() will introduce redundant CSS properties, it preserves the styling
            // of the different levels of topics.
            .copyCSS($label)
            // Apply additional CSS adjustments.
            .css({
                position: "absolute",
                width: (isFForIE ? $label[0].scrollWidth + 4 : $label[0].scrollWidth) + "px",
                height: "24px",
                left: ($label.offset().left - 2) + "px",
                top: ($label.offset().top - 1) + "px",
                textOverflow: "clip",
                overflow: "visible",
                maxWidth: "none",
                border: "1px solid #EBEBEB",
                zIndex: 2,
                backgroundColor: "#EBEBEB"
            })
            // Make the mouse-over layer disappear on mouse-out.
            .mouseleave(function () {
                $(this).hide();
            })
            // Show the layer.
            .show();
    }
};

gtn.ui.findNodeByText = function (itemNodes, targetNodeText) {
    if (targetNodeText) {
        var targetNodeText = gtn.ui.hyphenDecode(targetNodeText).toLowerCase();
        var targetNode = itemNodes.filter(function (index) {
            return $(this).find("> div > .k-in").text().toLowerCase() == targetNodeText;
        });
        return targetNode;
    } else {
        // Return all the item nodes un-filtered.
        return itemNodes;
    }
};

gtn.ui.rearrangeBookmark = function (e) {
    // Prevent users from dragging one node onto another node.
    // Note the e.statusClass is without the "k-" prefix, but setStatusClass() requires it.
    if (e.statusClass == "add") {
        // deny the operation
        e.setStatusClass("k-denied");
    }
};

/* Encode a string into URL-friendly format. */
gtn.ui.hyphenEncode = function (value) {
    // 1. Change single hyphen to double hyphens.
    // 2. Change single whitespace to single hyphen.
    // 3. URI-encode other special characters.
    return encodeURIComponent(value.replace(/-/g, "--").replace(/\s/g, "-"));
};

/* Decode a string into display-friendly format. */
gtn.ui.hyphenDecode = function (value) {
    // 1. URI-decode special characters.
    // 2. Change all hyphens to whitespaces.
    // 3. Change double spaces (originally double hyphens) to single hyphen.
    return decodeURIComponent(value).replace(/-/g, " ").replace(/\s\s/g, "-");
};

gtn.ui.addCssRule = function (stylesheet, selector, rules, index) {
    // Default to inserting the rules at the top of the stylesheet, if not specified.
    // For inserting to the end of stylesheet, use styleSheet.cssRules.length as the index.
    index = index || 0;
	if ("insertRule" in stylesheet) {
		stylesheet.insertRule(selector + "{" + rules + "}", index);
	}
	else if ("addRule" in stylesheet) {
		stylesheet.addRule(selector, rules, index);
	}
};

gtn.ui.showCallout = function (calloutSelector, targetSelector, calloutOrientation, adjustment) {
    var $target = $(targetSelector);
    let targetEl = $target[0];
    var targetOffset = $target.offset();
    var $callout = $(calloutSelector);
    var calloutOffset = { top: 0, left: 0 };
    adjustment = adjustment || {};
    adjustment.top = adjustment.top || 0;
    adjustment.left = adjustment.left || 0;
    let pointerHeight = 12;
    let marginSpacing = 20;
    // Apply the new CSS class, so the callout size is accurate.
    $callout.addClass("callout-" + calloutOrientation);
    console.log($('body').scrollTop());
    switch (calloutOrientation) {
        case "top":
            calloutOffset.left = targetOffset.left + adjustment.left;
            calloutOffset.top = targetEl.getBoundingClientRect().top - targetEl.offsetHeight + adjustment.top;
            break;

        case "bottom":
            calloutOffset.left = targetOffset.left + adjustment.left;
            calloutOffset.top = targetEl.getBoundingClientRect().top + targetEl.offsetHeight + pointerHeight + marginSpacing + adjustment.top;
            break;

        case "right":
            calloutOffset.left = targetOffset.left + $target.outerWidth() + adjustment.left;
            calloutOffset.top = targetEl.getBoundingClientRect().top;
            break;

        case "left":
            calloutOffset.left = targetOffset.left - $callout.outerWidth() + adjustment.left;
            calloutOffset.top = targetEl.getBoundingClientRect().top;
            break;
    }

    // Adjust the pointer position of the callout, if requested and if it's allowed.
    if (adjustment.pointer) {
        // Create a new local stylesheet for inserting new rules.
        var styleTag = document.createElement('style');
        document.head.appendChild(styleTag);
        var styleSheet = styleTag.sheet || styleTag.styleSheet;

        switch (calloutOrientation) {
            case "top":
            case "bottom":
                // Only the left position of the pointer is allowed to be adjusted; top position is fixed.
                var newLeftPos = adjustment.pointer.left;
                if (newLeftPos && 0 <= newLeftPos && newLeftPos <= $callout.outerWidth()) {
                    var currentLeftPosStr = window.getComputedStyle($callout[0], ':before').getPropertyValue('left');
                    var newLeftPosStr = newLeftPos + "px";
                    if (currentLeftPosStr != newLeftPosStr) {
                        var newCssRule = 'left: ' + newLeftPosStr + ' !important;';
                        gtn.ui.addCssRule(styleSheet, calloutSelector + ':before', newCssRule);
                        gtn.ui.addCssRule(styleSheet, calloutSelector + ':after', newCssRule);
                    }
                }
                break;

            case "right":
            case "left":
                // Only the top position of the pointer is allowed to be adjusted; left position is fixed.
                var newTopPos = adjustment.pointer.top;
                if (newTopPos && 0 <= newTopPos && newTopPos <= $callout.outerHeight()) {
                    var currentTopPosStr = window.getComputedStyle($callout[0], ':before').getPropertyValue('top');
                    var newTopPosStr = newTopPos + "px";
                    if (currentTopPosStr != newTopPosStr) {
                        var newCssRule = 'top: ' + newTopPosStr + ' !important;';
                        gtn.ui.addCssRule(styleSheet, calloutSelector + ':before', newCssRule);
                        gtn.ui.addCssRule(styleSheet, calloutSelector + ':after', newCssRule);
                    }
                }
                break;
        }
    }

    $callout
        .css("top", "auto")    // Reset the top value before the offset() call.
        .css("left", "auto")   // Reset the left value before the offset() call.
        .offset(calloutOffset)
        .css("position", "fixed")
        .show();
};

if(typeof Prism === 'undefined') {
    window.Prism = {
        languages : {},
        hightlightAll : () => {
            console.warn('Prism.js has been blocked by your add blocker');
        }
    }
}

/*
    Get Started Tutorial
 */
$(document).on('bind-events-to-axml-page', () => {
    // Check if user has visited the start guide landing page.
    var visited = Cookies.get('start-guide-visited');
    var isStartPage = location.pathname === '/start';
    if(isStartPage) {
        // Show the prompt for first-time visitors.
        if (visited !== 'yes') {
            $('#FirstTimeUserPrompt').show();
            $(document).trigger('article:heightChange');
        }
        // Flag the start guide landing page as visited.
        Cookies.set('start-guide-visited', 'yes', { secure : true });
    }
});

module.exports = window.gtn = gtn;


// WEBPACK FOOTER //
// ./public/javascripts/GTNexus.Common.js